"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __exportStar = void 0 && (void 0).__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseString = exports.parseFile = exports.parseStream = exports.parse = exports.ParserOptions = exports.CsvParserStream = void 0;
var fs = __importStar(require("fs"));
var stream_1 = require("stream");
var ParserOptions_1 = require("./ParserOptions");
var CsvParserStream_1 = require("./CsvParserStream");
__exportStar(require("./types"), exports);
var CsvParserStream_2 = require("./CsvParserStream");
Object.defineProperty(exports, "CsvParserStream", {
  enumerable: true,
  get: function get() {
    return CsvParserStream_2.CsvParserStream;
  }
});
var ParserOptions_2 = require("./ParserOptions");
Object.defineProperty(exports, "ParserOptions", {
  enumerable: true,
  get: function get() {
    return ParserOptions_2.ParserOptions;
  }
});
exports.parse = function (args) {
  return new CsvParserStream_1.CsvParserStream(new ParserOptions_1.ParserOptions(args));
};
exports.parseStream = function (stream, options) {
  return stream.pipe(new CsvParserStream_1.CsvParserStream(new ParserOptions_1.ParserOptions(options)));
};
exports.parseFile = function (location) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return fs.createReadStream(location).pipe(new CsvParserStream_1.CsvParserStream(new ParserOptions_1.ParserOptions(options)));
};
exports.parseString = function (string, options) {
  var rs = new stream_1.Readable();
  rs.push(string);
  rs.push(null);
  return rs.pipe(new CsvParserStream_1.CsvParserStream(new ParserOptions_1.ParserOptions(options)));
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7QUFDQTtBQUNBO0FBQ0E7QUFHQUE7QUFDQTtBQUFTQztFQUFBQztFQUFBQztJQUFBLHdDQUFlO0VBQUE7QUFBQTtBQUN4QjtBQUFTRjtFQUFBQztFQUFBQztJQUFBLG9DQUFhO0VBQUE7QUFBQTtBQUVUQyxhQUFLLEdBQUcsVUFBK0JDLElBQXdCO0VBQUEsT0FDeEUsSUFBSUMsaUNBQWUsQ0FBQyxJQUFJQyw2QkFBYSxDQUFDRixJQUFJLENBQUMsQ0FBQztBQUFBO0FBRW5DRCxtQkFBVyxHQUFHLFVBQ3ZCSSxNQUE2QixFQUM3QkMsT0FBMkI7RUFBQSxPQUNIRCxNQUFNLENBQUNFLElBQUksQ0FBQyxJQUFJSixpQ0FBZSxDQUFDLElBQUlDLDZCQUFhLENBQUNFLE9BQU8sQ0FBQyxDQUFDLENBQUM7QUFBQTtBQUUzRUwsaUJBQVMsR0FBRyxVQUNyQk8sUUFBZ0I7RUFBQSxJQUNoQkYsOEVBQTZCLEVBQUU7RUFBQSxPQUNQRyxFQUFFLENBQUNDLGdCQUFnQixDQUFDRixRQUFRLENBQUMsQ0FBQ0QsSUFBSSxDQUFDLElBQUlKLGlDQUFlLENBQUMsSUFBSUMsNkJBQWEsQ0FBQ0UsT0FBTyxDQUFDLENBQUMsQ0FBQztBQUFBO0FBRWxHTCxtQkFBVyxHQUFHLFVBQ3ZCVSxNQUFjLEVBQ2RMLE9BQTJCLEVBQ0o7RUFDdkIsSUFBTU0sRUFBRSxHQUFHLElBQUlDLGlCQUFRLEVBQUU7RUFDekJELEVBQUUsQ0FBQ0UsSUFBSSxDQUFDSCxNQUFNLENBQUM7RUFDZkMsRUFBRSxDQUFDRSxJQUFJLENBQUMsSUFBSSxDQUFDO0VBQ2IsT0FBT0YsRUFBRSxDQUFDTCxJQUFJLENBQUMsSUFBSUosaUNBQWUsQ0FBQyxJQUFJQyw2QkFBYSxDQUFDRSxPQUFPLENBQUMsQ0FBQyxDQUFDO0FBQ25FLENBQUMiLCJuYW1lcyI6WyJfX2V4cG9ydFN0YXIiLCJPYmplY3QiLCJlbnVtZXJhYmxlIiwiZ2V0IiwiZXhwb3J0cyIsImFyZ3MiLCJDc3ZQYXJzZXJTdHJlYW1fMSIsIlBhcnNlck9wdGlvbnNfMSIsInN0cmVhbSIsIm9wdGlvbnMiLCJwaXBlIiwibG9jYXRpb24iLCJmcyIsImNyZWF0ZVJlYWRTdHJlYW0iLCJzdHJpbmciLCJycyIsInN0cmVhbV8xIiwicHVzaCJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=